import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DynamicDialogConfig, DynamicDialogRef, DialogService} from 'primeng/dynamicdialog';
import {ViewportService} from '../../../services/viewport.service';
import {Router} from '@angular/router';
import {UserModel} from '../../../models/User';
import {AirportsService} from '../../../services/airports.service';
import {openModalClose$} from '../../../utilities/helpers';
import {DepartureAirportsModalComponent, DepartureAirportsModalData} from '../departure-airports-modal/departure-airports-modal.component';
import {take} from 'rxjs/operators';
import {Airport} from '../../../models/AirportModel';
import {RefreshTrigger} from '../../../services/refresh.service';

@Component({
    selector: 'expired-deals-modal',
    templateUrl: './expired-deals-modal.component.html',
    styleUrl: './expired-deals-modal.component.css'
})
export class ExpiredDealsModalComponent implements OnInit {
    @Input() visible = false;
    @Input() user!: UserModel
    @Output() onClose = new EventEmitter<void>();

    dealRefreshTrigger!: RefreshTrigger;

    constructor(
        public ref: DynamicDialogRef,
        public config: DynamicDialogConfig,
        public viewport: ViewportService,
        public router: Router,
        public dialogService: DialogService,
        private airportsService: AirportsService
    ) {}

    ngOnInit() {
        this.user = this.config.data.user;
        this.dealRefreshTrigger = this.config.data.dealRefreshTrigger;
    }

    close() {
        this.ref.close();
    }

    openDepartures() {
        const maxDeparturesAllowed = this.user.maxDeparturesAllowed;
        this.airportsService.getUsersDepartures()
            .pipe(take(1))
            .subscribe(fullDepartures => {
                const config: Partial<DynamicDialogConfig<DepartureAirportsModalData>> = {
                    data: {
                        airports: fullDepartures,
                        user: this.user,
                        maxAirportCount: maxDeparturesAllowed,
                        dealRefreshTrigger: this.dealRefreshTrigger
                    },
                    header: 'Your Departure Airports',
                    styleClass: 'header-xl dashboard-modal'
                };
                const { close$ } = openModalClose$<DepartureAirportsModalData>(
                    this.dialogService,
                    DepartureAirportsModalComponent,
                    config
                );
            });

        this.ref.close();
    }
}
